import React from 'react';
import './CustomInput.scss';
import MediaQuery from 'react-responsive';
import ReactSelect from 'react-select';
import { string } from '../../localization';
import { Icons } from '../../utilities';

const customInput = props => {
  const getErrorBorderStyle = (inputType, valid) => {
    let errorBorder = '';
    if (inputType == 'text' || inputType == 'paragraph') {
      if (valid) {
        errorBorder = 'no-error-border';
      } else {
        errorBorder = 'error-border';
      }
    }
    if (inputType == 'paragraph') {
      errorBorder = [errorBorder, 'info-error-border'].join(' ');
    }
    if (inputType == 'upload') {
      errorBorder = 'no-error-border';
    }
    if (inputType == 'checkbox') {
      errorBorder = 'no-error-border-checkbox';
    }

    return errorBorder;
  };

  const drawInputField = (inputConfigValue, inputId) => {
    const { value } = props;
    if (inputConfigValue.type == 'text') {
      return (
        <input
          className='input-field '
          type={type}
          name={inputId}
          value={value}
          readOnly={inputConfigValue.readOnly}
          placeholder={inputConfigValue.placeholder}
          onChange={e => onChange(e.target.value, inputId)}
        />
      );
    }
    if (inputConfigValue.type == 'dropdown') {
      return (
        <div className='position-relative dropdown'>
          <ReactSelect
            className='react-select--dropdown'
            options={inputConfigValue.options}
            value={value}
            onChange={e => onChange(e, inputId)}
            isSearchable={false}
            placeholder={inputConfigValue.placeholder}
            styles={{
              control: base => ({
                ...base,
                '&:hover': { borderColor: 'gray' },
                border: '1px solid rgb(206,212,218)',
                borderRadius: '0px',
                boxShadow: 'none',
                borderRight: '1px solid rgb(206,212,218)',
                font: '13px/17px HPSimplifiedLight, Arial, sans-serif'
              }),
              option: provided => ({
                ...provided,
                color: '#000',
                padding: '5px',
                fontWeight: 'bold',
                font: '13px/17px HPSimplifiedLight, Arial, sans-serif'
              }),
              singleValue: base => ({
                ...base,
                color: 'black'
              })
            }}
          />
        </div>
      );
    }
    if (inputConfigValue.type == 'paragraph') {
      return (
        <textarea
          name={inputId}
          value={value}
          className={['input-field', 'text-area'].join(' ')}
          placeholder={inputConfigValue.placeholder}
          onChange={e => onChange(e.target.value, inputId)}
        />
      );
    }
    if (inputConfigValue.type == 'upload') {
      return (
        <div className='upload-file-name'>
          <div className='upload-btn-wrapper'>
            <div className='choose-file-label '>
              {inputConfigValue.placeholder}
            </div>
            <input
              type='file'
              name='myfile'
              onChange={e => {
                if (e.target.files && e.target.files[0]) {
                  const uploadedFile = e.target.files[0];
                  onChange(uploadedFile, inputId);
                }
              }}
            />
          </div>
          <span className='file-name'>{value && value.name}</span>
        </div>
      );
    }
    if (inputConfig.type == 'checkbox') {
      return (
        <div className='form-group form-check Check-box installation-inst-container'>
          <input
            type='checkbox'
            className='form-check-input'
            name={id}
            checked={value}
            onChange={e => onChange(e.target.checked, id)}
            style={{ cursor: 'pointer' }}
          />
          <label
            role='button'
            className='form-check-label installation-inst'
            htmlFor={id}
            onClick={e => onChange(e.target.checked, id)}
            onKeyDown={() => {}}
          >
            {label}
          </label>
        </div>
      );
    }

    return null;
  };

  const { id, type, label, onChange, validation, inputConfig } = props;
  return (
    <div
      className={['order-details-input-field', inputConfig.customClass].join(
        ' '
      )}
    >
      <label htmlFor='info'>
        {inputConfig.type != 'checkbox' ? label : ''}
        {inputConfig.moreInfoHandler ? (
          <button
            type='button'
            style={{ border: 'none', background: 'none', outline: 'none' }}
            onClick={() => {
              inputConfig.moreInfoHandler(id);
            }}
          >
            <img
              alt='info'
              id={id}
              className='detail-info'
              src={Icons.InfoDefault}
            />
          </button>
        ) : null}
        <MediaQuery query='(max-width: 767px)'>
          {validation.required ? (
            <span style={{ color: '#ff5b5b', paddingLeft: '5px' }}>*</span>
          ) : null}
        </MediaQuery>
      </label>
      <div className='position-relative'>
        {drawInputField(inputConfig, id)}
        <div className='error-container'>
          <div
            className={getErrorBorderStyle(inputConfig.type, validation.valid)}
          />
          {validation.required ? (
            <div className='required'>{string.REQUIRED_STRING_KEY}</div>
          ) : null}
          {!validation.valid ? (
            <div className='error-message'>{validation.errorMessage}</div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default customInput;
